// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    domainPartner: 'services',
    domainPartners: ['services', 'apiplatform', 'web', 'preprod', 'prod', 'staging', 'qa', 'stable'],
    staticSite: 'https://apiplatform.io',

    apihost: 'https://services.apiplatform.io',
    apihostname: 'services.apiplatform.io',
    apiURL: 'https://services.apiplatform.io/v1/',

    identityHost: 'https://identity.apiplatform.io',
    identityHostname: 'identity.apiplatform.io',

    kingerHost: 'https://kinger-services.apiplatform.io',
    kingerHostName: 'kinger-services.apiplatform.io',

    deepLearningServer: 'https://deeplearning.apiplatform.io',

    pythonServicesServer: 'https://servicesv2.apiplatform.io',
    pythonServerHostName: 'servicesv2.apiplatform.io',
    // schedulerServer: 'http://localhost:5000',
    schedulerServer: 'https://scheduler.apiplatform.io',
    camundaServer: 'https://camunda.apiplatform.io/engine-rest',
    // deepLearningServer: 'http://3.84.224.19:5000',
    kongnewadminhost: 'https://new.gateway.apiplatform.io:9443',
    kongadminhost: 'https://admin.gateway.apiplatform.io',
    adminGatewayHost: 'admin.gateway.apiplatform.io',
    adminPort: 80,
    konghost: 'https://gateway.apiplatform.io',
    googleAnalytics: false,
    freshdeskConfig: {
        domain : 'apiplatform',
        api_key : 'kD5Ic3Xg6UE7AL3jq',
    },
    isOnPremise: false,
    platformRedirectURL: 'https://console.apiplatform.io',
    platformConsole: 'https://console.apiplatform.io',

    iamhost: 'https://iam.apiplatform.io',
    appclientPkey: '3fd6b9db619f724c3f834d44247b76c03fb31341c449ef183fed8bcfda90b7bc',
    appclientAPIKey: 'wdwffgefg4122455asdadfvf',

    adminPkey: '3fd6b9db619f724c3f834d44247b76c03fb31341c449ef183fed8bcfda90b7bc',

    thirdPartyPkey: '3fd7244d02a830763fcddf5c572a5b54',

    b2bPKey: '3fd7244d02a830763fcddf5c572a5b54',
    b2bAPIKey: 'IQ6wX1IABxeusz7tPln6lS375FDAWF66',

    billingPkey: '3fee0e37fef58a553fddddb61efd53e4',

    templatesPkey: '3fe41b41ed1b380a3fef0342c76a973b',

    commonsPkey: '3fe18f9884ea832e3fede1e661740c4a',

    AWSAPIKey: 'DBnsIEzlsP7uqEA3C1bjn2ael5BtYRH2atjDA1A3',

    captchaAPIKey: 'VbTqJFL35SCseJlHfF3Vqc31LmkSxsAK',
    captchaPkey: '3fe408b3a9da46563fecb834832ef39d',

    campaignHost: 'https://campaign.gateway.apiplatform.io',
    campaignPkey: '3fe936d53cafa2913fbf2b31b9c0de60',
    campaignAPIKey: '2RCBm34HkqV3ToNEJWCOrOJ3Noa9VQ6s',

    serviceshost: 'https://services.gateway.apiplatform.io',
    servicesPkey: '3fd99a6cdda045e23fb310d0ba17f868',
    servicesAPIKey: '6aRV9kJkeD6tiCqtMMINA0ycDOLlSeE5',

    autServiceshost: 'https://aut-services.gateway.apiplatform.io',
    autServicesPkey: '3fc8916b4a6087283fe1283a21608780',
    autServicesAPIKey: '6aRV9kJkeD6tiCqtMMINA0ycDOLlSeE5',

    coreHost: 'https://core.gateway.apiplatform.io',
    corePkey: '3feee3f13ffecbc23fdcb845d0b9359a',
    coreAPIKey: 'WroK6tWEFqf6lOtO7J1qJPXCZUc8Ai24',
    coreHmacUsername: 'admin-core',
    coreHmacSecret: 'iVv2wKTBL5Sn4hNcKOqDS71aXSPwwEpW',

    dataTransformHost: 'https://transformer.apiplatform.io',

    accountsHost: 'https://accounts.gateway.apiplatform.io',
    accountsHmacUsername: 'accounts-admin',
    accountsHmacSecret: 'w5XNzOk5mGg5UwKK2CaMZ88eRRFcSoDQ',

    integrationsHost: 'https://integrations.gateway.apiplatform.io',
    integrationsPkey: '3fda21de1d3576de3fedab1970c81cc6',
    integrationsAPIKey: 'AL4kyGpLvhQ11B7dSqYZMMBNP5KnQWMR',

    apiServiceshost: 'https://api-services.gateway.apiplatform.io',
    apiServicesPkey: '3fb1aa34307c55d83fd619a202c7fccc',
    apiServicesAPIKey: '6aRV9kJkeD6tiCqtMMINA0ycDOLlSeE5',

    monitoringhost: 'https://monitoring.gateway.apiplatform.io',
    monitoringPkey: '3fcc4377c588c1643fe93bbefe9f1486',
    monitoringAPIKey: 'Fk7pqfhYfDjHrUc94ekZW2XiVLZR6HsD',

    samplesPkey: '3feed7583137ec2f3fdc384d00c1a1e8',
    samplesAPIKey: 'ihle8P94JqTFLOjQ8FdBXOsiSeWGOboq',

    linkzyHost: 'linkzy.gateway.apiplatform.io',

    kommunicateAppId: '3bc85ce3484d1c14e4f7d626d54e24fc8',

    cipheringPhrase: 'a0ceb129cb3f04226c780099137d4608',
    tokenAESSecret: 'uvpRhVxdnfCin4MujH7hoZuA5bbP6AR9w1jWpNk7rd0SKiVAKhlNg2ZCdjpMUM6EitcaJEAfrSW0F5cPzBMPBT6DabVx8F2IrmWF',
    // authenticatorTokenAESSecret: 'iB6D50a15ukXQwmbgO9IF3neFx2Bk7Sdvhki4bbu6QQHUpUzVBIQytPoVFJEKt1eekhO2h0owK5djCp4FLXMFbMtI3Fp1PCsKYFF',
    authenticatorTokenAESSecret: 'lkHsQ85p6ZRfc0hx6lpoNZVZFuFmtZ5F1551E38a1vqpcGNMp0GZLBaGtTmFEO36NS32Pr00Pp9PHGWklSPuCXzXEPuXK9c8zSyU',

    headersDescription: {
        'API-PLATFORM-PARTNER': 'A unique identifier for a partner registered with the apiplatform.io. The partner details can be viewed under settings section  of the apiplatform.io console, navigating through the menu: Settings → Partner Settings → Accounts.',
        'API-PLATFORM-ACCOUNT': 'A unique identifier for a particular account created under a partner. Each partner will get a default account in the name of the partner itself. A partner may have multiple accounts and can manage all his/her accounts under settings section  of the apiplatform.io console, navigating through the menu: Settings → Partner Settings → Accounts.',
        'API-PLATFORM-PARTNER-KEY': 'A unique key generated, when a partner is signed up, which will then used to validate the authenticity of the partner. A partner key is same for all the accounts associated with a partner. It is required for all  kinds of operations including accessing or managing any asset/resource owned by the partner and his/her sub-accounts. It is available under  Settings section  of the apiplatform.io console, navigating through the menu: Settings → Partner Settings → Accounts.',
        'API-PLATFORM-ACCOUNT-KEY': 'A unique key to validate a specific account created under the partner. It is mandatory for the accounts other than default account. It is available under Settings section of the apiplatform.io console, navigating through the menu: Settings → Partner Settings → Accounts.',
        'API-PLATFORM-KEY': 'A unique key of a user/consumer on-boarded with the platform, used to authenticate an API  access through the gateway. You can manage the API keys from the Settings section  of the apiplatform.io console navigating through the menu: Settings → Partner Settings → API Keys.',
        'API-NAME': 'A unique identifier of an API. The name of an API is always simple and intuitive to provide consistent developer experience.',
        'VERSION': 'The version of an API, allows you to alter behaviour between different APIs with same name, all of which may have the same general function but are improved, upgraded or customized.',
        'Content-Type': 'It is used to specify the nature of the data in the body of an entity, by giving type and subtype identifiers. In general, the top-level Content-Type is used to declare the general type of data, while the subtype specifies a specific format for that type of data. For example, a Content-Type of "application/json" implies that the data is binary  and the specific data format is "json". ',
    },

    // accessHost: 'https://dev-access.gateway.apiplatform.io',
    // accessPartner: 'dev-access',
    accessHost: 'https://access.gateway.apiplatform.io',
    accessPartner: 'access',
    accessPkey: '3fe071f61268428c3fda5d9b2e968612',
    accessAPIKey: 'BgSwgualyz1WDL4h25flSXAesjZdS5W0',
    devAccessPkey: '3feb09ca1c885a663fb2f8f5ca7412d0',

    defaultDatabaseRegion: 'us-east-1',

    accessTokenLocalStoreKey: 'apat$',

    coreAPI: {
        alerts: {
            name: 'alerts',
            version: 'v1'
        },
        trigger: {
            name: 'triggerConfig',
            version: 'v1'
        },
        triggersLog: {
            name: 'triggersLog',
            version: 'v1'
        },
        alertConfig: {
            name: 'alertConfig',
            version: 'v1'
        },
        alertsManager: {
            name: 'alertsManager',
            version: 'v1'
        },
        alertsInfo: {
            name: 'alertsInfo',
            version: 'v1'
        },
        applicationLogicBlocks: {
            name: 'application-logic-blocks',
            version: 'v1'
        },
        applicationLogicSubscriptionBlocks: {
            name: 'application-logic-subscription-blocks',
            version: 'v1'
        },
        triggers: {
            name: 'triggers',
            version: 'v1'
        },
        devToolsBlocks: {
            name: 'dev-tools-blocks',
            version: 'v1'
        },
        jsScripts: {
            name: 'js-scripts',
            version: 'v1'
        },
        log: {
            name: 'log',
            version: 'v1'
        },
        uploadFiletoS3: {
            name: 'upload-file-to-s3',
            version: 'v1'
        },
        sessionData: {
            name: 'sessionData',
            version: 'v1'
        },
        sessionsList: {
            name: 'sessionsList',
            version: 'v1'
        }
    },

    integrationsAPI: {
        accelerators: {
            name: 'accelerators',
            version: 'v1'
        },
        accelerator: {
            name: 'accelerator',
            version: 'v1'
        },
        acceleratorConnectors : {
            name: 'acceleratorConnectors',
            version: 'v1'
        },
        b2bserviceproviders: {
            name: 'b2b-service-providers',
            version: 'v1'
        },
        serviceProviderSubscriptions : {
            name: 'service-provider-subscriptions',
            version: 'v1'
        },
        validateProviderSubscriptions : {
            name: 'validate-accelerator-subscriptions',
            version: 'v1'
        }
    },

    pubsubtitles: {
        API_REQUIREMENTS: 'API REQUIREMENTS',
        API_DESIGN: 'API DESIGN',
        API_DEVELOPMENT: 'API DEVELOPMENT',
        API_TESTING: 'API TESTING',
        API_DEPLOYMENT: 'API DEPLOYMENT',
        API_SECURITY: 'API SECURITY',
        API_GATEWAY_MANAGEMENT: 'API GATEWAY MANAGEMENT',
        API_DOCUMENTATION: 'API DOCUMENTATION',
        API_REDEPLOYMENT: 'API REDEPLOYMENT',
        DONE: 'DONE'
    },
    auditLogPermissions: {
        isAuditForAuth: true,
        isAuditForApiGateway: false,
        isAuditForDataAccess: false,
        isAuditForBusinessLogic: false,
        isAuditForSQLQuery: false,
        isAuditForTestSuite: false,
        isAuditForWorkflow: false,
        isAuditForPermissions: false,
        isAuditForAPIIntegrations: false,
        isAuditForDevex: false,
        isAuditForNotifyErrorToAdmins: false,
        isAuditForFileManager: false,
        isAuditForDataCatalog: false,
        isAuditForDigitalTransformer: false,
        isAuditForDeploymentPlan: false,
        isAuditForScheduler: false,
        isAuditForEmailTemplates: false,
        isAuditForDatabases: false,
        isAuditForIdleTimeout: false,
        isAuditForLogout: false,

        login_submit_next_clicked: true,
        login_submit_next_success: true,
        login_submit_next_failed: true,
        signup_submit_next_clicked: true,
        signup_submit_next_success: true,
        signup_submit_next_failed: true,
        signup_submit_verifyotp_clicked: true,
        signup_submit_resendotp_clicked: true,
        signup_submit_resendotp_success: true,
        signup_submit_resendotp_failed: true,
        signup_onboarding_resendverificationlink_success: true,
        signup_onboarding_resendverificationlink_failed: false,
        signup_onboarding_notifyerrortoadmins_success: true,
        signup_onboarding_notifyerrortoadmins_failed: true,
        signup_onboarding_dnsvalidation_success: true,
        signup_onboarding_dnsvalidation_failed: true,
        signup_onboarding_environmentrecreation_success: true,
        signup_onboarding_environmentrecreation_failed: true,
        signup_onboarding_patchadminpartnersettings_failed: true,
        signup_onboarding_patchadminpartnersettings_success: true,
        signup_onboarding_environmentcreation_success: true,
        signup_onboarding_environmentcreation_failed: true,
        signup_onboarding_configureapikeyauthentication_failed: true,
        signup_onboarding_usercreation_success: true,
        signup_onboarding_usercreation_failed: true,
        signup_onboarding_rolecreation_success: true,
        signup_onboarding_rolecreation_failed: true,
        signup_onboarding_settingscreation_success: true,
        signup_onboarding_settingscreation_failed: true,
        signup_onboarding_executeemail_failed: true,
        signup_onboarding_executeemail_success: true,

        apigateway_services_update_clicked: true,
        apigateway_services_update_success: true,
        apigateway_services_update_failed: true,
        apigateway_services_addgatewaysettings_clicked: true,
        apigateway_services_addgatewaysettings_success: true,
        apigateway_services_addgatewaysettings_failed: true,
        apigateway_services_applytoroute_clicked: true,
        apigateway_services_applytoroute_success: true,
        apigateway_services_applytoroute_failed: true,
        apigateway_routes_addgatewaysettings_clicked: true,
        apigateway_routes_addgatewaysettings_success: true,
        apigateway_routes_addgatewaysettings_failed: true,
        apigateway_servicesplugins_edit_clicked: true,
        apigateway_servicesplugins_edit_success: true,
        apigateway_servicesplugins_edit_failed: true,
        apigateway_servicesplugins_delete_clicked: true,
        apigateway_servicesplugins_delete_success: true,
        apigateway_servicesplugins_delete_failed: true,
        apigateway_routesplugins_edit_clicked: true,
        apigateway_routesplugins_edit_success: true,
        apigateway_routesplugins_edit_failed: true,
        apigateway_routesplugins_delete_clicked: true,
        apigateway_routesplugins_delete_success: true,
        apigateway_routesplugins_delete_failed: true,

        apigateway_services_create_success: true,
        apigateway_services_create_failed: true,
        apigateway_routes_create_success: true,
        apigateway_routes_create_failed: true,


        dataaccessapi_create_deploy_clicked: true,
        dataaccessapi_create_deploy_success: true,
        dataaccessapi_create_deploy_failed: true,
        dataaccessapi_edit_redeploy_clicked: true,
        dataaccessapi_edit_redeploy_success: true,
        dataaccessapi_edit_redeploy_failed: true,
        dataaccessapi_create_save_clicked: true,
        dataaccessapi_create_save_success: true,
        dataaccessapi_create_save_failed: true,
        dataaccessapi_edit_save_clicked: true,
        dataaccessapi_edit_save_success: true,
        dataaccessapi_edit_save_failed: true,

        businesslogic_create_deploy_clicked: true,
        businesslogic_create_deploy_success: true,
        businesslogic_create_deploy_failed: true,
        businesslogic_edit_redeploy_clicked: true,
        businesslogic_edit_redeploy_success: true,
        businesslogic_edit_redeploy_failed: true,
        businesslogic_debug_test_clicked: true,
        businesslogic_debug_test_success: true,
        businesslogic_debug_test_failed: true,
        businesslogic_create_save_clicked: true,
        businesslogic_create_save_success: true,
        businesslogic_create_save_failed: true,
        businesslogic_edit_save_clicked: true,
        businesslogic_edit_save_success: true,
        businesslogic_edit_save_failed: true,

        workflow_create_deploy_clicked: true,
        workflow_create_deploy_success: true,
        workflow_create_deploy_failed: true,
        workflow_edit_redeploy_clicked: true,
        workflow_edit_redeploy_success: true,
        workflow_edit_redeploy_failed: true,
        workflow_create_save_clicked: true,
        workflow_create_save_success: true,
        workflow_create_save_failed: true,
        workflow_edit_save_clicked: true,
        workflow_edit_save_success: true,
        workflow_edit_save_failed: true,

        testsuite_create_deploy_clicked: true,
        testsuite_create_deploy_success: true,
        testsuite_create_deploy_failed: true,
        testsuite_edit_redeploy_clicked: true,
        testsuite_edit_redeploy_success: true,
        testsuite_edit_redeploy_failed: true,
        testsuite_create_save_clicked: true,
        testsuite_create_save_success: true,
        testsuite_create_save_failed: true,
        testsuite_edit_save_clicked: true,
        testsuite_edit_save_success: true,
        testsuite_edit_save_failed: true,
        testsuite_debug_test_clicked: true,
        testsuite_debug_test_success: true,
        testsuite_debug_test_failed: true,
        testsuite_create_addtestcase_clicked: true,
        testsuite_edit_addtestcase_clicked: true,
        testsuite_create_deletetestcase_clicked: true,
        testsuite_edit_deletetestcase_clicked: true,
        testsuite_create_addprestep_clicked: true,
        testsuite_edit_addprestep_clicked: true,
        testsuite_create_addpoststep_clicked: true,
        testsuite_edit_addpoststep_clicked: true,
        testsuite_create_savepresteps_clicked: true,
        testsuite_edit_savepresteps_clicked: true,
        testsuite_create_savepoststeps_clicked: true,
        testsuite_edit_savepoststeps_clicked: true,
        testsuite_create_deletestep_clicked: true,
        testsuite_edit_deletestep_clicked: true,

        sqlquery_create_deploy_clicked: true,
        sqlquery_create_deploy_success: true,
        sqlquery_create_deploy_failed: true,
        sqlquery_edit_redeploy_clicked: true,
        sqlquery_edit_redeploy_success: true,
        sqlquery_edit_redeploy_failed: true,
        sqlquery_statement_execute_clicked: true,
        sqlquery_statement_execute_success: true,
        sqlquery_statement_execute_failed: true,
        sqlquery_script_execute_clicked: true,
        sqlquery_script_execute_success: true,
        sqlquery_script_execute_failed: true,
        sqlquery_create_save_clicked: true,
        sqlquery_create_save_success: true,
        sqlquery_create_save_failed: true,
        sqlquery_edit_save_clicked: true,
        sqlquery_edit_save_success: true,
        sqlquery_edit_save_failed: true,

        dataaccessapi_delete_clicked: true,
        dataaccessapi_delete_success: true,
        dataaccessapi_delete_failed: true,
        dataaccessapi_data_delete_success: true,
        dataaccessapi_data_delete_failed: true,
        dataaccessapi_apiexecutors_delete_success: true,
        dataaccessapi_apiexecutors_delete_failed: true,
        dataaccessapi_gatewayconfigurations_delete_success: true,
        dataaccessapi_gatewayconfigurations_delete_failed: true,

        businesslogic_delete_clicked: true,
        businesslogic_delete_success: true,
        businesslogic_delete_failed: true,
        businesslogic_apiexecutors_delete_success: true,
        businesslogic_apiexecutors_delete_failed: true,
        businesslogic_gatewayconfigurations_delete_success: true,
        businesslogic_gatewayconfigurations_delete_failed: true,

        sqlquery_delete_clicked: true,
        sqlquery_delete_success: true,
        sqlquery_delete_failed: true,
        sqlquery_apiexecutors_delete_success: true,
        sqlquery_apiexecutors_delete_failed: true,
        sqlquery_gatewayconfigurations_delete_success: true,
        sqlquery_gatewayconfigurations_delete_failed: true,

        thirdparty_delete_clicked: true,
        thirdparty_delete_success: true,
        thirdparty_delete_failed: true,
        thirdparty_apiexecutors_delete_success: true,
        thirdparty_apiexecutors_delete_failed: true,
        thirdparty_gatewayconfigurations_delete_success: true,
        thirdparty_gatewayconfigurations_delete_failed: true,

        workflow_delete_clicked: true,
        workflow_delete_success: true,
        workflow_delete_failed: true,
        workflow_apiexecutors_delete_success: true,
        workflow_apiexecutors_delete_failed: true,
        workflow_gatewayconfigurations_delete_success: true,
        workflow_gatewayconfigurations_delete_failed: true,

        dmn_delete_clicked: true,
        dmn_delete_success: true,
        dmn_delete_failed: true,
        dmn_apiexecutors_delete_success: true,
        dmn_apiexecutors_delete_failed: true,
        dmn_gatewayconfigurations_delete_success: true,
        dmn_gatewayconfigurations_delete_failed: true,

        testsuite_delete_clicked: true,
        testsuite_delete_success: true,
        testsuite_delete_failed: true,
        testsuite_apiexecutors_delete_success: true,
        testsuite_apiexecutors_delete_failed: true,
        testsuite_gatewayconfigurations_delete_success: true,
        testsuite_gatewayconfigurations_delete_failed: true,

        serviceprovider_activate_success: true,
        serviceprovider_activate_failed: true,
        serviceprovider_deactivate_success: true,
        serviceprovider_deactivate_failed: true,
        serviceprovider_provider_create_success: true,
        serviceprovider_provider_create_failed: true,
        serviceprovider_providercategory_patch_success: true,
        serviceprovider_providercategory_patch_failed: true,
        serviceprovider_category_create_success: true,
        serviceprovider_category_create_failed: true,
        serviceprovider_connector_create_success: true,
        serviceprovider_connector_create_failed: true,
        serviceprovider_connector_delete_success: true,
        serviceprovider_connector_delete_failed: true,
        serviceprovider_connector_delete_clicked: true,
        serviceprovider_connector_test_success: true,
        serviceprovider_connector_test_failed: true,
        serviceprovider_connector_test_clicked: true,

        devex_tester_execute_clicked: true,
        devex_tester_execute_success: true,
        devex_tester_execute_failed: true,
        devex_tester_update_clicked: true,
        devex_tester_update_success: true,
        devex_tester_update_failed: true,
        devex_register_apiplatform_clicked: true,
        devex_register_apiplatform_success: true,
        devex_register_apiplatform_failed: true,
        devex_register_asis_clicked: true,
        devex_register_asis_success: true,
        devex_register_asis_failed: true,
        devex_documentation_publish_clicked: true,
        devex_documentation_publish_success: true,
        devex_documentation_publish_failed: true,
        devex_documentation_execute_clicked: true,
        devex_documentation_execute_success: true,
        devex_documentation_execute_failed: true,


        signup_onboarding_checkpartnershortcodeexistence_success: true,
        signup_onboarding_checkpartnershortcodeexistence_failed: true,
        signup_onboarding_getpartnerkey_failed: true,
        signup_onboarding_getpartnerkey_success: true,
        signup_onboarding_createconsumerinapigateway_failed: true,
        signup_onboarding_createconsumerinapigateway_success: true,
        signup_onboarding_createdefaultconsumerinapigateway_failed: true,
        signup_onboarding_createdefaultconsumerinapigateway_success: true,
        signup_onboarding_configureapikeyauthentication_success: true,
        signup_onboarding_partnercreation_success: true,
        signup_onboarding_partnercreation_failed: true,
        signup_onboarding_updateonboardingtoken_success: true,
        signup_onboarding_updateonboardingtoken_failed: true,
        signup_onboarding_getapikey_failed: true,
        signup_onboarding_getapikey_success: true,

        filemanager_uploadfile_clicked: true,
        filemanager_uploadfile_success: true,
        filemanager_uploadfile_failed: true,
        filemanager_uploadfolder_clicked: true,
        filemanager_uploadfolder_success: true,
        filemanager_uploadfolder_failed: true,
        filemanager_createfolder_clicked: true,
        filemanager_createfolder_success: true,
        filemanager_createfolder_failed: true,
        filemanager_deletefolder_clicked: true,
        filemanager_deletefolder_success: true,
        filemanager_deletefolder_failed: true,
        filemanager_deletefile_clicked: true,
        filemanager_deletefile_success: true,
        filemanager_deletefile_failed: true,

        datacatalog_dictionary_update_clicked: true,
        datacatalog_dictionary_update_success: true,
        datacatalog_dictionary_update_failed: true,
        datacatalog_deployasapi_showdeploymentplan_clicked: true,
        datacatalog_deployasapi_showdeploymentplan_success: true,
        datacatalog_deployasapi_showdeploymentplan_failed: true,

        digitaltransformer_listdatabaseobjects_clicked: true,
        digitaltransformer_listdatabaseobjects_success: true,
        digitaltransformer_listdatabaseobjects_failed: true,
        digitaltransformer_showdeploymentplan_clicked: true,
        digitaltransformer_showdeploymentplan_success: true,
        digitaltransformer_showdeploymentplan_failed: true,

        deploymentplan_deploy_clicked: true,
        deploymentplan_deploy_success: true,
        deploymentplan_deploy_failed: true,
        deploymentplan_transform_clicked: true,
        deploymentplan_transform_success: true,
        deploymentplan_transform_failed: true,

        scheduler_schedule_clicked: true,
        scheduler_schedule_success: true,
        scheduler_schedule_failed: true,
        scheduler_reschedule_clicked: true,
        scheduler_reschedule_success: true,
        scheduler_reschedule_failed: true,
        scheduler_resume_clicked: true,
        scheduler_resume_success: true,
        scheduler_resume_failed: true,
        scheduler_pause_clicked: true,
        scheduler_pause_success: true,
        scheduler_pause_failed: true,
        scheduler_delete_clicked: true,
        scheduler_delete_success: true,
        scheduler_delete_failed: true,
        scheduler_edit_clicked: true,
        scheduler_edit_success: true,
        scheduler_edit_failed: true,

        emailtemplate_create_clicked: true,
        emailtemplate_create_success: true,
        emailtemplate_create_failed: true,
        emailtemplate_edit_clicked: true,
        emailtemplate_edit_success: true,
        emailtemplate_edit_failed: true,
        emailtemplate_delete_clicked: true,
        emailtemplate_delete_success: true,
        emailtemplate_delete_failed: true,
        emailtemplate_execute_clicked: true,
        emailtemplate_execute_success: true,
        emailtemplate_execute_failed: true,
        emailtemplate_schedule_clicked: true,
        emailtemplate_schedule_success: true,
        emailtemplate_schedule_failed: true,

        databaseconnection_create_clicked: true,
        databaseconnection_insertdatabase_success: true,
        databaseconnection_insertdatabase_failed: true,
        databaseconnection_create_success: true,
        databaseconnection_create_failed: true,
        databaseconnection_updatedatabaseconnection_success: true,
        databaseconnection_updatedatabaseconnection_failed: true,
        databaseconnection_test_clicked: true,
        databaseconnection_test_success: true,
        databaseconnection_test_failed: true,
        databaseconnection_edit_clicked: true,
        databaseconnection_edit_success: true,
        databaseconnection_edit_failed: true,
        databaseconnection_delete_clicked: true,
        databaseconnection_delete_success: true,
        databaseconnection_delete_failed: true,
        databaseconnection_removedatabaseconnection_success: true,
        databaseconnection_removedatabaseconnection_failed: true,

        idletimeout_update_clicked: true,
        idletimeout_update_success: true,
        idletimeout_update_failed: true,

        logout_clicked: true,
        logout_success: true,
    },

    signupTitles: {
        PARTNER_CREATION: 'PARTNER REGISTRATION',
        ADMIN_ACCOUNT_CREATION: 'SUPER ADMIN ENVIRONMENT CREATION',
        DEV_ACCOUNT_CREATION: 'DEVELOPMENT ENVIRONMENT CREATION',
    }
};



/*
 * In development mode, for easier debugging, you can ignore zone related error
 * stack frames such as `zone.run`/`zoneDelegate.invokeTask` by importing the
 * below file. Don't forget to comment it out in production mode
 * because it will have a performance impact when errors are thrown
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
